module.exports = __webpack_public_path__ + "img/bg_yellow.daf9b256.svg";